export const SET_SEGMENTS = "setSegments";
export const CLEAR_SEGMENTS = "clearSegments";
export const SET_SEGMENT = "setSegment";
export const CLEAR_SEGMENT = "clearSegment";
export const SET_NAME = "setName";
export const SET_SURVEYS = "setSurveys";
export const SET_DISTRIBUTIONS = "setDistributions";
export const SET_SENDING_CHANNEL = "setSendingChannel";
export const SET_ANSWER_CHANNEL = "setAnswerChannel";
export const SET_SENDING_DATE = "setSendingDate";
export const SET_ANSWER_DATE = "setAnswerDate";
export const SET_ANSWER_STATUS = "setAnswerStatus";
export const SET_SEND_STATUS = "setSendStatus";
export const SET_IDENTIFICATION = "setIdentification";
export const SET_HEALTH_SCORE = "setHealthScore";
export const SET_CATEGORIES = "setCategories";
export const SET_METADATA = "setMetadata";
export const ADD_SEGMENT = "addSegment";
export const REMOVE_SEGMENT = "removeSegment";
export const SET_SURVEY_OPTIONS = "setSurveyOptions";
export const CLEAR_SURVEY_OPTIONS = "clearSurveyOptions";
export const SET_DISTRIBUTION_OPTIONS = "setDistributionOptions";
export const CLEAR_DISTRIBUTION_OPTIONS = "clearDistributionOptions";
export const SET_METADATA_OPTIONS = "setMetadataOptions";
export const CLEAR_METADATA_OPTIONS = "clearMetadataOptions";
export const SET_CATEGORY_OPTIONS = "setCategoryOptions";
export const CLEAR_CATEGORY_OPTIONS = "clearCategoryOptions";
export const SET_STATIC_SEGMENT = "setStaticSegment";
